/**
 * Header Interceptor.
 */

module.exports = function (_) {

    return {

        request: function (request) {

            request.method = request.method.toUpperCase();
            request.headers = _.extend({}, _.http.headers.common,
                !request.crossOrigin ? _.http.headers.custom : {},
                _.http.headers[request.method.toLowerCase()],
                request.headers
            );

            if (_.isPlainObject(request.data) && /^(GET|JSONP)$/i.test(request.method)) {
                _.extend(request.params, request.data);
                delete request.data;
            }

            return request;
        }

    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/header.js
// module id = 228
// module chunks = 1